"use client"

import { forwardRef, type Ref } from "react"
import { clsx } from "clsx"

import type { PropsWithClassName } from "~/@types/generics"
import type { ProductCardProps } from "~/components/ui/Product/ProductCard"
import { AbstractSkeleton } from "~/components/abstracts/Skeleton/index.client"

import { sprinkles } from "~/styles/sprinkles.css"

import * as css from "./styles.css"

function ForwardedProductCardSkeleton(
  { className, layout = "large" }: PropsWithClassName & Pick<ProductCardProps, "layout">,
  ref: Ref<HTMLDivElement>
) {
  return (
    <div ref={ref} className={clsx(className, css.skeleton)}>
      <div className={css.imageContainer}>
        <div className={sprinkles({ ratio: "6/7" })}>
          <AbstractSkeleton />
        </div>
      </div>

      <div className={css.head[layout]}>
        <div className={clsx(css.firstCol[layout], sprinkles({ position: "relative", width: "100%" }))}>
          <div className={clsx(css.titleText[layout])}>
            <AbstractSkeleton />
          </div>
          <div className={clsx(css.subtitleText[layout])}>
            <AbstractSkeleton />
          </div>
        </div>
        <div className={clsx(css.secondCol[layout], sprinkles({ position: "relative", width: "100%" }))}>
          <div className={clsx(css.colorsText[layout])}>
            <AbstractSkeleton />
          </div>
          <div className={css.priceText[layout]}>
            <span className={css.productPriceWithoutReduction}>
              <AbstractSkeleton />
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}

export const ProductCardSkeleton = forwardRef(ForwardedProductCardSkeleton)
